// utils/pricing.js
export function priceForBudget(rangeGoals) {
  // tiny normalizer so "$10k - 25k", "$10,000–$25,000" etc. still match
  const key = String(rangeGoals)
    .replace(/,/g, "")                 // remove commas
    .replace(/\s+/g, "")               // remove spaces
    .replace(/[\u2013\u2014]/g, "-")   // en/em dash -> hyphen
    .toUpperCase();                    // normalize case

  switch (key) {
    case "UNDER$10000":
      // no tier defined; return null or a default if you want
      return null;

    // $10,000–$49,999 bracket
    case "$10K-$25K":
    case "$26K-$35K":
    case "$36K-$50K":
      return { fee: 100, code: "FIRST50", firstLeadDiscount: 50 };

    // $50,000–$75,000 bracket (include if you ever use this label)
    case "$50K-$75K":
    case "$51K-$75K":
      return { fee: 300, code: "FIRST150", firstLeadDiscount: 150 };

    // $76,000+ bracket — always FIRST250
    case "$76K+":
    case "$76000+":
    case "OVER$100K":
    case "$51K-$100K":
      return { fee: 500, code: "FIRST250", firstLeadDiscount: 250 };

    default:
      return null;
  }
}

